exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader {\n  background: rgba(255, 255, 255, 0);\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  padding-top: 5rem;\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  align-items: self-start;\n}", ""]);

// exports
